<template>
    <div>
        <b-card>
            <b-card-body class="p-0">
                <b-row>
                    <!-- Title -->
                    <b-col class="text-left align-middle my-auto">
                        <h3>{{ buying_cost_name }}</h3>
                    </b-col>
                    <!-- Cost amount -->
                    <b-col
                        class="text-sm-left text-md-right align-middle my-auto"
                    >
                        <h1 class="text-orange m-0 text-nowrap">
                            {{ buying_cost_currency }}
                            {{ formatted_currency(buying_cost_amount) }}
                        </h1>
                    </b-col>
                    <!-- Buttons -->
                    <b-col class="col-12 col-sm-3  text-left text-sm-right align-middle my-auto pr-sm-4">
                        <base-button
                            type="default"
                            size="sm"
                            :pill="true"
                            @click="$emit('edit', buying_cost_id)"
                        >
                            <i class="fas fa-wrench"></i>
                        </base-button>
                        <base-button
                            type="danger"
                            size="sm"
                            :pill="true"
                            @click="$emit('delete', buying_cost_id, buying_cost_name)"
                        >
                            <i class="fa fa-trash"></i>
                        </base-button>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
//Custom Components

export default {
    name: "BuyingCostsItem",
    emits: ["edit", "delete"],
    components: {},
    props: {
        buying_cost_id: {
            type: String,
            description: "ID of the buying_cost",
            default: "",
        },
        buying_cost_name: {
            type: String,
            description: "Name of the buying_cost",
            default: "",
        },
        buying_cost_amount: {
            type: Number,
            description: "Amount of the buying_cost",
            default: "",
        },
        buying_cost_currency: {
            type: String,
            description: "Currency of the buying_cost",
            default: "",
        },
    },

    data() {
        return {};
    },
    methods: {
        formatted_currency(value) {
            return value.toLocaleString();
        },
    },
    watch: {},
};
</script>
<style></style>
